import jumia from "../../../assets/jumia.png";
import shopbop from "../../../assets/shopbop.png";
import Marquee from "react-fast-marquee";

const MarqueeComponent = () => {
  const images = [
    {
      src: jumia,
      alt: "Image 1",
    },
    {
      src: shopbop,
      alt: "Image 2",
    },
    {
      src: jumia,
      alt: "Image 1",
    },
    {
      src: shopbop,
      alt: "Image 2",
    },
    {
      src: jumia,
      alt: "Image 2",
    },
  ];
  return (
    <div className="mt-10">
      <Marquee>
        {images.map((image, index) => (
          <div key={index} className="w-52 mx-8">
            <img className="w-full" src={image.src} alt={image.alt} />
          </div>
        ))}
      </Marquee>
      <div className="mt-5">
        <Marquee>
          {images.map((image, index) => (
            <div key={index} className="w-52 mx-8">
              <img className="w-full" src={image.src} alt={image.alt} />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default MarqueeComponent;
